export { default as SubCollectionCardListDS } from './sub-collection-card-list-ds'
